const backendUrl = 'https://sca-qa.herokuapp.com/';

export default backendUrl;
